import { useTheme } from '@shopify/restyle';
import { IconChevronRight } from '@tabler/icons-react-native';
import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { Theme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import type { ReactNode } from 'react';
import { Pressable, View } from 'react-native';

interface ActionRowProps {
  prefix: ReactNode;
  text: string;
  onPress: () => void;
  withChevron?: boolean;
}

export function ActionRow({ prefix, text, onPress, withChevron = true }: ActionRowProps) {
  const theme = useTheme<Theme>();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={text}
      onPress={onPress}
      style={({ pressed }) => ({
        justifyContent: 'center',
        paddingVertical: theme.spacing['spacing.general.x1'],
        opacity: pressed ? 0.65 : 1,
      })}
    >
      <Row alignItems="center" gap="spacing.general.x5">
        <View style={{ width: 30, height: 30, flexShrink: 0, alignItems: 'center', justifyContent: 'center' }}>
          {prefix}
        </View>
        <Text flex={1} minWidth={0} variant="bodyBase">
          {text}
        </Text>
        {withChevron ? <IconChevronRight size={24} strokeWidth={ICON_STROKE_WIDTH} style={{ flexShrink: 0 }} /> : null}
      </Row>
    </Pressable>
  );
}
